import { render, staticRenderFns } from "./ValidVoterEnquiry.vue?vue&type=template&id=2ac8b476&scoped=true&"
import script from "./ValidVoterEnquiry.vue?vue&type=script&lang=js&"
export * from "./ValidVoterEnquiry.vue?vue&type=script&lang=js&"
import style0 from "./ValidVoterEnquiry.vue?vue&type=style&index=0&id=2ac8b476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8b476",
  null
  
)

export default component.exports